import React from 'react';
import AdminV2Cashback from '../cashback';

/**
 * Admin V2 Cashback Payments — Réutilise AdminV2Cashback avec filtre 'paid'.
 * Route : /admin/cashback-payments (V2Switcher) + /admin/v2/cashback-payments.
 * Feature : pages.cashback.payments.
 */
const AdminV2CashbackPayments = () => <AdminV2Cashback defaultStatus="paid" />;

export default AdminV2CashbackPayments;
